import React from 'react'

import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { ContentButtonPart } from 'common/builder/components/chart/FlowChart/hooks/useTextContentParts'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import * as styles from './TextContentButton.style'

interface TextContentButtonProps {
  contentPart: ContentButtonPart
  buttons: FlowChartButton[]
}

export const TextContentButton = (props: TextContentButtonProps) => {
  const button = props.buttons.find((button) => button.id === props.contentPart.buttonId)

  if (!button) {
    return null
  }

  return <Button button={button} style={styles.SmartLink} />
}
